import { api } from "@/lib/api";

const CS = "https://images.contentstack.io/v3/assets/blt70a7e9d08c98ce54/";

export const CATEGORIES = [
  {
    id: "nutrizione",
    banner: CS + "blt0fa23852b6cda73c/67f6468b90ae067e072ee709/Nutrition_PLP_Banner.jpg",
    thumb: CS + "bltf41f8a608144cf34/68ee413733892a822aa761e5/homepage_nutrizione_1.webp",
    subs: ["base", "mirati", "immunitarie", "cellule", "cuore", "ossa", "erbe", "lei", "lui", "bambini", "pelle", "attivo", "peso", "frappe", "barrette", "te", "bevande", "italiani", "accessori"],
  },
  {
    id: "bellezza",
    banner: CS + "bltd4b6f269ba3d716c/67f65f29b62f3b10d434b649/Beauty_PLP_Banner.jpg",
    thumb: CS + "blt48b224cf1dd2e97f/68ee4331e5bae4efd1a28ecf/homepage_beauty_1.webp",
    subs: ["detergenti", "creme", "occhi", "antieta", "trattamenti", "set", "viso", "occhi-trucco", "labbra", "accessori"],
  },
  {
    id: "casa",
    banner: CS + "bltf975ed9552c70f0c/67f63ddb929efb8acbc7d760/Home_PLP_Banner.jpg",
    thumb: CS + "blt7cd6311565a430e3/68ee43638c9abb1ab5faa5cc/homepage_casa_1.webp",
    subs: ["bucato", "superfici", "cucina-bagno", "stoviglie", "dosatori", "cucina", "coltelleria", "acqua", "aria", "accessori"],
  },
  {
    id: "persona",
    banner: CS + "blt2fb309452585b6dd/67ed3373deb05612f3b03ad1/Personal_Care_PLP_Banner.jpg",
    thumb: CS + "blt4d248f67b177259c/68ee42ede4391f1fd19642f8/homepage_persona_1.webp",
    subs: ["shampoo", "trattamento-capelli", "corpo", "saponi", "saponette", "idratazione", "deodoranti", "solari", "orale"],
  },
];

export const PRODUCTS = [];
export let BRANDS = [];

export const loadCatalog = async () => {
  const { data } = await api.get("/products");
  PRODUCTS.splice(0, PRODUCTS.length, ...data);
  BRANDS = [...new Set(PRODUCTS.map((p) => p.brand))].sort();
  return PRODUCTS;
};

export const getProduct = (code) => PRODUCTS.find((p) => p.code === code);
export const byCategory = (cat) => PRODUCTS.filter((p) => p.cat === cat);

export const HERO_SLIDES = [
  { id: "xs", img: CS + "bltea43fdaefb873659/6a8d7535c8ced922f80551a5/xs-elite-october_09-26_hero-banner_936x560.webp", link: "/p/342214" },
  { id: "omega", img: CS + "blt351b2c8d54610fd7/6a688bfa17e9eeff49e3907c/omega-sheet-mask_07-26_hero-banner_1372x1120.webp", link: "/p/128275" },
  { id: "derma", img: CS + "bltef949187ebc4a163/6a958d89f08ee158738530d4/pure-beauty-award_08-26_hero-banner_1372x1120.webp", link: "/p/127720" },
  { id: "nutrilite", img: CS + "blt2ccf2df298ed0bd6/6a969bae5c3126369f43ef27/PY-promotion_08-26_hero-banner_936x560_nutrilite.webp", link: "/c/nutrizione" },
];

export const BRAND_TILES = [
  { name: "Nutrilite™", img: CS + "blt341b146dd3123c58/6939473424cf001f4c057036/portfolio_nutrilite.webp", cat: "nutrizione" },
  { name: "Artistry™", img: CS + "bltf728169b3e5e6052/693947b9b9d04cb2633ec999/portfolio_artistry.webp", cat: "bellezza" },
  { name: "eSpring™", img: CS + "blt48d0d7612fc98d98/693946966f4f53a7355e3720/portfolio_eSpring.webp", cat: "casa" },
  { name: "XS™", img: CS + "blt2dcdca465f18fbeb/6939473ee5644469816108ad/portfolio_xs.webp", cat: "nutrizione" },
  { name: "g&h™", img: CS + "bltd9ffcd84e6f7bff8/693947173a0ed87890a7b4be/portfolio_g&h.webp", cat: "persona" },
  { name: "Glister™", img: CS + "blt33d2f8add01b4b88/69cd13d8dfb8e01382dfb6fb/portfolio_Glister_new.webp", cat: "persona" },
  { name: "iCook™", img: CS + "blt54710514053a1926/6939472b94c63b163ec7bb5d/portfolio_iCook.webp", cat: "casa" },
  { name: "Amway Home™", img: CS + "bltcaff6f7e7f38840c/693947ab85cc6d45f0520d6b/portfolio_AmwayHome.webp", cat: "casa" },
  { name: "Satinique™", img: CS + "blta86e666a7da8feda/693947483a0ed8716ba7b4ce/portfolio-satinique_c10_186x119.webp", cat: "persona" },
  { name: "Atmosphere Sky™", img: CS + "bltc5d60af7d390943e/693947587d6ae477855b9057/portfolio-sky_c10_186x119.webp", cat: "casa" },
];

export const fmtPrice = (n, lang = "it") =>
  new Intl.NumberFormat(lang === "en" ? "en-IE" : lang === "es" ? "es-ES" : "it-IT", { style: "currency", currency: "EUR" }).format(n);
